
export const formTypeRatioDough = 'rdough'
export const formTypeWeightDough = 'qdough'
export const formTypeLevain = 'levain'

export const BATCH_TYPE_FLOUR_WT = 'FW'
export const BATCH_TYPE_TOTAL_WT = 'TW'

export const LEVAIN_PCT_TYPE_NONE = 'NONE'
export const LEVAIN_PCT_TYPE_PFF = 'PFF'
export const LEVAIN_PCT_TYPE_TOTAL_WT = 'TW'

export const BAKERS_YEAST_TYPE_DRY = 'DRY'
export const BAKERS_YEAST_TYPE_CAKE = 'CAKE'

export const SUBMIX_TYPE_PORRIDGE = 'pr'
export const SUBMIX_TYPE_SCALD = 'sc'
export const SUBMIX_TYPE_SOAKER = 'sk'

export const noPreferment = 'none'
export const liquidLevain = 'liquidLevain'
export const stiffLevain = 'stiffLevain'
export const pastaMadre = 'pastaMadre'
export const panettone = 'panettone'
export const dough1 = 'dough1'
export const poolish = 'poolish'
export const biga = 'biga'
export const pateFermente = 'pateFermente'

export const ingredientWater = 'water'
export const ingredientFlour = 'flour'
export const ingredientDryYeast = 'dryYeast'
export const ingredientFreshYeast = 'freshYeast'
export const ingredientLevain = 'levain'
export const ingredientUnknown = 'unknown'

export const ingredientTypeGrain = 'grain'
export const ingredientTypeLiquid = 'liquid'
export const ingredientTypeInclusion = 'inclusion'
export const ingredientTypeTopping = 'topping'


export const LOW_HYDRATION_PCT_THRESHOLD = 65
export const PREFERMENT_BUFFER_MIN_WEIGHT = 12
export const PREFERMENT_BUFFER_PCT_FRACTION = 0.03

export const prefermentTypeMap = [
  {
    prefermentType: noPreferment,
    prefermentLabel: 'None',
    defaultHydrationPct: 0,
    defaultPffPct: 0,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 0,
    starterPct: 0,
    isYeast: false
  },
  {
    prefermentType: liquidLevain,
    prefermentLabel: 'Liquid Levain',
    defaultHydrationPct: 100,
    defaultPffPct: 20,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 0,
    starterPct: 20,
    isYeast: false
  },
  {
    prefermentType: stiffLevain,
    prefermentLabel: 'Stiff Levain',
    defaultHydrationPct: 60,
    defaultPffPct: 20,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 0,
    starterPct: 20,
    isYeast: false
  },
  {
    prefermentType: pastaMadre,
    prefermentLabel: 'Pasta Madre',
    defaultHydrationPct: 50,
    defaultPffPct: 20,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 0,
    starterPct: 20,
    isYeast: false
  },
  {
    prefermentType: panettone,
    prefermentLabel: 'Panettone Levain',
    defaultHydrationPct: 45,
    defaultPffPct: 18,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 0,
    starterPct: 20,
    isYeast: false
  },
  {
    prefermentType: dough1,
    prefermentLabel: 'Enrichment Pre-Mix',
    defaultHydrationPct: 65,
    defaultPffPct: 18,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 0,
    starterPct: 20,
    isYeast: false
  },
  {
    prefermentType: poolish,
    prefermentLabel: 'Poolish',
    defaultHydrationPct: 100,
    defaultPffPct: 20,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 4,
    starterPct: 0,
    isYeast: true
  },
  {
    prefermentType: pateFermente,
    prefermentLabel: 'Pâte Fermentée',
    defaultHydrationPct: 60,
    defaultPffPct: 20,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 4,
    starterPct: 0,
    isYeast: true
  },
  {
    prefermentType: biga,
    prefermentLabel: 'Biga',
    defaultHydrationPct: 35,
    defaultPffPct: 20,
    prefermentPffPctType: LEVAIN_PCT_TYPE_TOTAL_WT,
    yeastRatioId: 4,
    starterPct: 0,
    isYeast: true
  }
]

export function getSubMixDescr(subMixType) {
  switch(subMixType) {
    case SUBMIX_TYPE_PORRIDGE: return 'Porridge'
    case SUBMIX_TYPE_SCALD: return 'Scald'
    case SUBMIX_TYPE_SOAKER: return 'Soaker'
    default: return undefined
  }
}

export function getSubMixDefaultName(subMixType) {
  switch(subMixType) {
    case SUBMIX_TYPE_PORRIDGE: return 'Porridge'
    case SUBMIX_TYPE_SCALD: return 'Scald'
    case SUBMIX_TYPE_SOAKER: return 'Soaker'
    default: return undefined
  }
}

export function getPrefermentPctTypeOptionLabel(prefermentPctType) {
  return prefermentPctType === LEVAIN_PCT_TYPE_PFF ? 'PFF %' : 'Weight %'
}

export function getPrefermentPctTypeRecipeLabel(prefermentPct, prefermentPctType) {
  return prefermentPctType === LEVAIN_PCT_TYPE_PFF ? `(${prefermentPct}% PFF)` : ''
}

export const MAX_PREFERMENT_PFF_PCT = 45
export const THEORETICAL_MAX_PREFERMENT_PFF_PCT = 90
export const MAX_PREFERMENT_WEIGHT_PCT = 100
export const THEORETICAL_MAX_PREFERMENT_WEIGHT_PCT = 900

export function getMaxPrefermentPctForType(prefermentPctType) {
  return prefermentPctType === LEVAIN_PCT_TYPE_PFF ? THEORETICAL_MAX_PREFERMENT_PFF_PCT : THEORETICAL_MAX_PREFERMENT_WEIGHT_PCT
}

export function getMaxSliderPrefermentPctForType(prefermentPctType) {
  return prefermentPctType === LEVAIN_PCT_TYPE_PFF ? MAX_PREFERMENT_PFF_PCT : MAX_PREFERMENT_WEIGHT_PCT
}

export function getPrefermentDefinition(prefermentType) {
  let preferment = prefermentTypeMap.find((p) => p.prefermentType === prefermentType)
  if (preferment === undefined) {
    return noPreferment
  }
  return preferment
}

export function getPrefermentLabel(prefermentType) {
  let preferment = prefermentTypeMap.find((p) => p.prefermentType === prefermentType)
  if (preferment === undefined) {
    return 'None'
  }
  return preferment.prefermentLabel
}

export function getPrefermentPffPct(prefermentType) {
  let preferment = prefermentTypeMap.find((p) => p.prefermentType === prefermentType)
  if (preferment === undefined) {
    return 0
  }
  return preferment.defaultPffPct
}

export function isYeastPreferment(prefermentType) {
  let preferment = prefermentTypeMap.find((p) => p.prefermentType === prefermentType)
  if (preferment === undefined) {
    return false
  }
  return preferment.isYeast
}

export const Exception = {
  componentName: '',
  methodName: '',
  message: ''
}

export function createException(component, method, message) {
  return {...Exception, componentName: component, methodName: method, message: message}
}
